<template>
  <div>
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item prop="selectedPatient">
        <el-select
          v-model="form.selectedPatient"
          :placeholder="$t('text.select')"
          class="wp-100"
          :loading="loading"
        >
          <el-option
            v-for="item in patients"
            :key="item.PatientId"
            :label="item.Alias"
            :value="item.PatientId"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      form: {
        selectedPatient: ''
      },
      rules: this.initRules(),
      patients: [],
      loading: false
    }
  },
  mounted() {
    this.getPatients()
  },
  watch: {
    'form.selectedPatient': function() {
      this.handlePatientChange()
    }
  },
  methods: {
    handlePatientChange() {
      let selectedPatient
      this.patients.forEach(item => {
        if (item.PatientId === this.form.selectedPatient) {
          selectedPatient = item
        }
      })
      this.$emit('patientChange', selectedPatient)
    },
    initRules() {
      return {
        selectedPatient: [
          {
            required: true,
            message: this.$t('text.select'),
            trigger: 'change'
          }
        ]
      }
    },
    getPatients() {
      this.loading = true
      ApiService.GetAllPatientsV3(
        this.$store.getters[`filter/calculatedFilter`].organisationId,
        this.$store.getters[`filter/calculatedFilter`].flag,
        this.$store.getters[`filter/calculatedFilter`].filterIds
      )
        .then(response => {
          this.loading = false
          let currentOrganisation = response.data.data.filter(
            item =>
              item.OrganisationId ===
              this.$store.getters[`user/selecteOrganisationId`]
          )
          if (currentOrganisation && currentOrganisation.length) {
            this.patients = currentOrganisation[0].ActivePatients.map(item => {
              return {
                ...item,
                DayManufacturerId: item.DayManufacturerId || '',
                DayProductId: item.DayProductId || '',
                NightProductId: item.NightProductId || '',
                NightManufacturerId: item.NightManufacturerId || '',
                DayStartTime: item.DayStartTime || '',
                DayEndTime: item.DayEndTime || '',
                NightStartTime: item.NightStartTime || '',
                NightEndTime: item.NightEndTime || '',
                AllocatedPod: item.AllocatedPod.substring(
                  item.AllocatedPod.length - 4
                )
              }
            })
          }
          if (this.form.selectedPatient) {
            this.handlePatientChange()
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
